import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { messageOf } from '../api/problem';

export interface ProblemMessageProps {
  readonly error: FetchBaseQueryError | SerializedError | undefined;
}

/** Shows a request failure; renders nothing when there is none. */
export function ProblemMessage({ error }: ProblemMessageProps) {
  if (error === undefined) {
    return null;
  }
  return (
    <p role="alert" className="problem">
      {messageOf(error)}
    </p>
  );
}
